import { useCallback } from 'react';
import useWeb3 from '../useWeb3';
import { getTrade } from '../../utils/contractHelpers';

export const EntryShares = () => {
    const web3 = useWeb3();
    const entrySharesHook = useCallback(async (address, selectionOptionIndex ,amountinWeiNum) => {
        const contract = getTrade(address, web3);
        try {
            const entryShares = await contract.methods.getEntryShares(selectionOptionIndex ,amountinWeiNum).call();
            return entryShares;
        } catch (e) {
            console.error("Transaction error:", e.message || e);
            throw e;
        }
    }, [web3]);

    return  {entrySharesHook} ;
};

export default EntryShares;
